import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00c42bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "md-timepicker"
}
const _hoisted_2 = {
  key: 0,
  class: "timepicker-backdrop"
}
const _hoisted_3 = {
  key: 1,
  class: "timepicker"
}
const _hoisted_4 = { class: "selected-date-wrapper" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "picker-content" }
const _hoisted_7 = { class: "clock-wrapper" }
const _hoisted_8 = { class: "clock" }
const _hoisted_9 = { class: "hand" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "hours"
}
const _hoisted_12 = { class: "clock-container" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "clock-container small" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "00", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "minutes"
}
const _hoisted_19 = { class: "clock-container" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!

  return (_openBlock(), _createBlock(_Transition, { name: "picker" }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.visible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.visible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", _hoisted_5, [
                      _createElementVNode("span", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mode = 'hours')),
                        class: _normalizeClass({ active: _ctx.mode === 'hours' })
                      }, _toDisplayString(("0" + _ctx.selectedHour).slice(-2)), 3),
                      _createTextVNode(":"),
                      _createElementVNode("span", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'minutes')),
                        class: _normalizeClass({ active: _ctx.mode === 'minutes' })
                      }, _toDisplayString(("0" + _ctx.selectedMinute).slice(-2)), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("div", {
                            class: "stick",
                            style: _normalizeStyle({
                    transform:
                      'translate(-50%, -50%) rotate(' + _ctx.degree + 'deg)',
                  })
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["background", { small: _ctx.mode === 'hours' && (_ctx.selectedHour > 12 || _ctx.selectedHour === 0) }])
                            }, null, 2)
                          ], 4)
                        ]),
                        (_ctx.mode === 'hours')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
                                  return _createElementVNode("div", {
                                    key: n,
                                    class: _normalizeClass(["number", [
                      'deg-' + n * 30,
                      n === _ctx.selectedHour ? 'active' : '',
                    ]]),
                                    onClick: ($event: any) => (_ctx.selectHour(n))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(n), 1)
                                  ], 10, _hoisted_13)
                                }), 64))
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (n, k) => {
                                  return _createElementVNode("div", {
                                    key: k,
                                    class: _normalizeClass(["number", [
                      'deg-' + (k + 1) * 30,
                      n + 12 === _ctx.selectedHour ? 'active' : '',
                    ]]),
                                    onClick: ($event: any) => (_ctx.selectHour(n + 12))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(n + 12), 1)
                                  ], 10, _hoisted_15)
                                }), 64)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["number deg-360", { active: 0 === _ctx.selectedHour }]),
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectHour(0)))
                                }, _hoisted_17, 2)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
                                  return _createElementVNode("div", {
                                    key: n - 1,
                                    class: _normalizeClass(["number", [
                      'deg-' + (n - 1) * 30,
                      (n - 1) * 5 === _ctx.selectedMinute ? 'active' : '',
                    ]]),
                                    onClick: ($event: any) => (_ctx.selectMinute((n - 1) * 5))
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString((n - 1) * 5), 1)
                                  ], 10, _hoisted_20)
                                }), 64))
                              ])
                            ]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_md_button, {
                        variant: "text",
                        grey: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Abbrechen ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_md_button, {
                        variant: "text",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.select()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Übernehmen")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}